import script from "./HostingMonthlyTable.vue?vue&type=script&setup=true&lang=js"
export * from "./HostingMonthlyTable.vue?vue&type=script&setup=true&lang=js"

import "./HostingMonthlyTable.vue?vue&type=style&index=0&id=2c52af2c&lang=css"

const __exports__ = script;

export default __exports__